import { ClientTag } from "@avenueops/shared-types";

interface Props {
  tag: ClientTag | Pick<ClientTag, "id" | "color" | "dynamicTags">;
  workflowId?: string;
}

export function TagIcon({ tag, workflowId }: Props) {
  const uniqueWorkflowColumns = Array.from(
    new Set(tag.dynamicTags?.filter((dynamicTag) => (workflowId ? dynamicTag.workflowId === workflowId : true)).map((dynamicTag) => dynamicTag.workflowColumn))
  );

  return tag.color && (!tag.dynamicTags || tag.dynamicTags.length === 0) ? (
    <div className="self-center rounded-full w-3 h-3 shrink-0 mr-2" style={{ background: tag.color }} />
  ) : (
    <div className="inline-flex gap-0.5">
      {!workflowId || uniqueWorkflowColumns.length === 0 ? (
        <div className="self-center font-medium text-xs text-gray-800 mr-1 inline-flex">{`{{}}`}</div>
      ) : (
        uniqueWorkflowColumns.map((column) => (
          <div key={column} className="self-center font-medium text-xs text-gray-800 mr-1 inline-flex">
            {`{{`}
            <div className=" font-normal">{column}</div>
            {`}}`}
          </div>
        ))
      )}
    </div>
  );
}
